import { FilterOptionValue } from '../../types';
import { BrowseServiceProductsData } from './types';

// Replace + with space and decode as URI component
const decodeOptionValue = (optionValue: FilterOptionValue) => {
  if (typeof optionValue === 'string') {
    return decodeURIComponent(optionValue.replace(/\+/g, ' '));
  }

  return optionValue;
};

// TODO: split this transformer up into products and filters transforms, which would
//       be called in (or done directly in) the reducers rather than the thunk?
export const transformBrowseServiceProductsToReduxState = (
  browseServiceProductsData: BrowseServiceProductsData,
) => {
  const {
    category,
    currencyCode,
    products: items,
    currentPage,
    totalPages,
    filters,
    totalProducts,
    productsReturnedCount,
    queryType,
    sortingOptions,
    navigation,
    partner,
  } = browseServiceProductsData;

  return {
    category,
    currencyCode,
    items: { [currentPage]: items },
    // Decode filter option values. Remove when browse-data-api does this for us
    filters: filters.map((filter) => ({
      ...filter,
      options: filter.options.map((option) => ({
        ...option,
        value: decodeOptionValue(option.value),
      })),
    })),
    currentPage,
    totalPages,
    totalProducts,
    productsReturnedCount,
    queryType,
    sortingOptions,
    navigation,
    partner,
  };
};
